/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ExternalAccessGrantDto {
  accessKey?: string;
  adapterId?: number;
  comment?: string;
  fineGrainedGrants?: Array<string>;
  grants?: Array<string>;
  id?: number;
  ownerState?: string;
  ownerUsername?: string;
  token?: string;
  tokenId?: string;
  type?: string;
}
